/* eslint-disable max-lines */
/* PE Modular Progressive Enhancement Framework
   @License: MIT (http://www.opensource.org/licenses/mit-license.php)
   @Author: Michiel Kikkert
   @Version: 2.0
   @Date: September 2011
   Needs the jQuery Library.
   Expects a modules file containing _PE.module objects to parse.

   ********
   USAGE *
   ********
   Include PE-Framework.js
   Include My-Modules.js
   Include jQuery library
   Include module dependent jQuery plugins

   Starting the framework

   //Create an [optional] overwrite config object (overwrites _PE.config items):
   var oOptions = {moduleOrder:['mainNav','productTree','carousel'],debug:true};

   //Create an new Framework instance, passing in the [optional] overwrite object and an [optional] jQuery object (required if other libs like Prototype also exist on the page)
   var application = new _PE.app(oOptions,jQuery.noConflict());

   //Boot the framework:
   application.boot();

   PLEASE NOTE:
   Inside the _PE namespaced modules, jQuery has been abstracted as the _PE.config.jquery value (DEFAULT: $).
   Please change this to a different value if it conflicts with another library.
    */

/* Var _pad = function(str) { while (str.length < 48) str+=' '; return str; };
   var _log = console.log; window.console.log = function(log){ var message = '%cLooks like you\'re trying to log a' + (arguments.length > 1 ? ' lot' : (typeof log === 'object' ? 'n' : '')), style = 'background:url(http://i.imgur.com/SErVs5H.png); background-repeat: no-repeat; padding:5px 15px 142px 19px;line-height:280px;'; _log.call(console, _pad(message + ' ' + (arguments.length > 1 ? '' : typeof log) + '.'), style); };
   var _info = console.info; window.console.info = function(log){ var message = '%cLooks like you\'re trying to log a' + (arguments.length > 1 ? ' lot' : (typeof log === 'object' ? 'n' : '')), style = 'background:url(http://i.imgur.com/SErVs5H.png); background-repeat: no-repeat; padding:5px 15px 142px 19px;line-height:280px;'; _info.call(console, _pad(message + ' ' + (arguments.length > 1 ? '' : typeof log) + '.'), style); }; */
/* eslint-disable no-implicit-globals */
/* eslint-disable  no-underscore-dangle*/
/* eslint-disable id-match */
/* eslint-disable init-declarations */
/* eslint-disable block-scoped-var */
/* eslint-disable vars-on-top */
/* eslint-disable id-length */
var _PE;

/* eslint-disable mysticatea/block-scoped-var */
if (typeof _PE !== 'object') {
  /* eslint-disable no-redeclare */
  var _PE = {};
  /* eslint-enable no-redeclare */
  /* eslint-enable id-match */
  /* eslint-enable  no-underscore-dangle*/
  var $peVersion = '2.0';
}

/* eslint-enable no-implicit-globals */
/* eslint-enable mysticatea/block-scoped-var */

_PE = {
/* eslint-disable  mysticatea/block-scoped-var */
  version: $peVersion,
  /* eslint-enable  mysticatea/block-scoped-var */
  /* eslint-enable block-scoped-var */
  /* Set default config options. Can be overwritten by passing in an options object to 'app'*/
  config: {
    debug: false,
    globalErrorHandling: true,
    UrlShowTrace: true,
    benchmarkFile: '/js/benchmark.js',
    jquery: '$',
    ajaxConfig: {
      dataType: 'json',
      type: 'POST',
      success: function(data) {
      /* eslint-disable block-scoped-var */
        _PE.core.ajax.globalSuccess(data);
      },
      error: function(error) {
        _PE.utils.trace('AJAX REQUEST FAILED', 'warn');
        _PE.utils.trace(error.status + ', ' + error.statusText);
        _PE.utils.trace(error);
        /* eslint-enable block-scoped-var */
      }
    },
    minjQueryVersion: '1.7',
    moduleOrder: []
  },
  metaData: [],
  modules: {},
  fn: {},
  vars: null,
  registeredFunctions: [],
  registeredEvents: [],
  NS: '_PE',
  framework: {
    ready: false,
    timings: {},
    env: {}
  },
  path: [],
  /* Main Constructor*/
  app: function(options, jQueryObj) {
    if (typeof options === 'undefined') {
      /* eslint-disable no-param-reassign */
      options = {};
    }

    /* eslint-disable block-scoped-var */
    /* eslint-disable no-undef*/
    jQuery.extend(true, _PE.config, options);

    /* eslint-enable no-undef*/
    if (typeof jQueryObj === 'undefined') {
      /* eslint-disable max-statements-per-line*/
      _PE.utils.trace('jQuery object not passed in, trying to assign default $'); jQueryObj = window.$;
      /* eslint-enable max-statements-per-line */
      /* eslint-enable no-param-reassign */
    }

    if (typeof options.minjQueryVersion !== 'undefined') {
      _PE.config.minjQueryVersion = options.minjQueryVersion;
      /* eslint-enable  block-scoped-var */
    }


    if (typeof options.debug !== 'undefined') {
      /* eslint-disable  block-scoped-var */
      _PE.config.debug = options.debug;
    }


    if (!_PE.jQueryAssign(jQueryObj)) {
      return {
        boot: function() {
          _PE.utils.trace('PE Framework failed to boot. jQuery missing or wrong version', 'warn');
        }
      };
    }


    return _PE;
  },

  jQueryAssign: function(jQuery) {
    try {
      // Test if jQuery passed in is really jQuery and if the version is correct:
      if (typeof jQuery === 'function') {
        // Could still be prototype
        if (typeof jQuery().jquery === 'string') {
        /* eslint-disable no-negated-condition*/
          if (!this.compareVersions(jQuery().jquery, _PE.config.minjQueryVersion)) {
          /* eslint-enable no-negated-condition*/
            /* eslint-disable no-throw-literal */
            throw 'jQuery version is too old. The PE framework needs at least version ' + _PE.config.minjQueryVersion;
          } else {
            /* eslint-disable max-len */
            _PE.utils.trace('Found jQuery version ' + jQuery().jquery + ' (version ' + _PE.config.minjQueryVersion + ' is required according to config).');
            _PE.utils.trace('Use ' + _PE.config.jquery + ' for jQuery in your modules');
            window[_PE.config.jquery] = jQuery;

            /* eslint-enable max-len */
            return true;
          }
        } else {
          throw 'You passed something in the app constructor, but it wasn\'t jQuery!';
        }
      } else {
        throw 'jQuery object not found. Please pass in a jQuery object into the app constructor';
      }
      /* eslint-enable no-throw-literal */
    } catch (err) {
      var e;

      _PE.utils.trace('FRAMEWORK ERROR', 'warn');
      _PE.utils.trace(e, 'warn');

      return false;
    }

    /* eslint-disable no-unreachable*/
    return false;
    /* eslint-enable no-unreachable*/
  },

  compareVersions: function(dottedUsed, dottedRequired) {
    var usedVersionParts = dottedUsed.split('.');
    var requiredVersionParts = dottedRequired.split('.');
    var factor = 10;
    var longest = 0;

    while (usedVersionParts.length < requiredVersionParts.length) {
      usedVersionParts.push('0');
    }

    while (requiredVersionParts.length < usedVersionParts.length) {
      requiredVersionParts.push('0');
    }

    /* eslint-disable no-ternary */
    for (var i = 0; i < usedVersionParts.length; i = i + 1) {
      longest = usedVersionParts[i].length > longest ? usedVersionParts[i].length : longest;
    }

    /* eslint-disable no-redeclare*/
    for (var i = 0; i < requiredVersionParts.length; i = i + 1) {
    /* eslint-enable no-redeclare*/
      longest = requiredVersionParts[i].length > longest ? requiredVersionParts[i].length : longest;
    }

    /* eslint-enable no-ternary */
    factor = Math.pow(factor, longest);

    var usedVersion = this.calcVersionNumbers(usedVersionParts, factor);
    var requiredVersion = this.calcVersionNumbers(requiredVersionParts, factor);

    return usedVersion >= requiredVersion;
  },

  calcVersionNumbers: function(versionParts, base) {
    var totalCount = 0;
    var start = 1;

    for (var i = versionParts.length; i > 0; i = i - 1) {
      /* eslint-disable no-mixed-operators */
      totalCount = totalCount + Math.pow(base, start) * versionParts[i - 1];
      /* eslint-enable no-mixed-operators */
      /* eslint-disable no-plusplus */
      ++start;
      /* eslint-enable no-plusplus */
    }

    return totalCount;
  },
  /* eslint-disable max-statements*/
  setEnv: function() {
  /* eslint-enable max-statements*/
    /* eslint-disable no-undef */
    for (var browser in jQuery.browser) {
      if (jQuery.browser[browser] === true) {
        _PE.framework.env.browser = browser;
      } else {
        _PE.framework.env.browserVersion = jQuery.browser[browser];
      }
    }

    var os = 'Unknown OS';
    var appv = navigator.appVersion;

    if (appv.indexOf('Win') !== -1) {
      os = 'Windows';
    }

    if (appv.indexOf('Mac') !== -1) {
      os = 'MacOS';
    }

    if (appv.indexOf('X11') !== -1) {
      os = 'UNIX';
    }

    if (appv.indexOf('Linux') !== -1) {
      os = 'Linux';
    }

    _PE.framework.env.os = os;

    if (typeof _PE.metaData.version !== 'undefined') {
      _PE.utils.trace('VERSION: ' + _PE.metaData.version);
      _PE.framework.version = _PE.metaData.version;
    }

    if (typeof _PE.metaData.buildnumber !== 'undefined') {
      _PE.utils.trace('BUILD: ' + _PE.metaData.buildnumber);
      _PE.framework.build = _PE.metaData.buildnumber;
    }
  },

  baseModule: {

    _construct: function() {
      _PE.utils.trace('MODULE:' + this.id + '::_construct() start');
      this.elements = jQuery(this.PEClass);

      if (this.elements.length === 0) {
        _PE.utils.trace('MODULE:' + this.id + ':Not Applicable');

        return;
      }

      _PE.core.timer('Module_' + this.id, true);
      _PE.core.attachData(this.elements, 'module');
      _PE.core.attachController(this, 'controller');

      try {
        this.init();
      } catch (err) {
        var e;

        _PE.utils.trace('Could not run the init method on module:' + this.id, 'warn');
        _PE.utils.trace(e, 'warn');
      }

      _PE.core.timer('Module_' + this.id, false);
    }
  },

  event: {
    trigger: function(customEvent) {
      _PE.registeredEvents.push(customEvent);
      jQuery(document).trigger(_PE.NS + '_' + customEvent);
    },
    bind: function(event, fn, args) {
      _PE.utils.trace('EVENT:BIND:: ' + _PE.NS + '_' + event);
      jQuery(document).bind(_PE.NS + '_' + event, args, fn);
    }
  },

  registerFunction: function(fn, event, oArgs) {
    try {
      var args = oArgs || {};

      _PE.registeredFunctions.push(fn + ' -> ' + event);
      _PE.event.bind(event, _PE.fn[fn], args);
    } catch (err) {
      _PE.utils.trace('Could not bind custom function ' + fn, 'warn');
    }
  },

  boot: function() {
    _PE.utils.trace('_PE.boot()');
    jQuery(document).ready(function() {
      /* Bind Framework events*/
      /* Abstraction of document.ready*/
      _PE.event.trigger('ready');
      _PE.event.bind('onFrameworkReady', function() {
        _PE.framework.ready = true;
        _PE.utils.trace('EVENTS:REGISTERED ' + _PE.registeredEvents.join(' :: '));
        _PE.utils.trace('FUNCTIONS:REGISTERED ' + _PE.registeredFunctions.join(' :: '));
      });
      _PE.event.trigger('onBeforeFrameworkInit');
      _PE.core.init();
      _PE.event.trigger('onFrameworkReady');
    });
  }
};
/*
   _PE core
    */

_PE.core = {
  /* _PE.core.init() method
     Determines main execution order of the framework.
     init() is called by $(document).ready which in turn
     is bound by _PE.boot(); */
  init: function() {
    try {
      _PE.core.timer('Application', true);
      _PE.utils.trace('_PE.core.init() START');
      _PE.core.setMetaData();
      _PE.core.setPath();
      _PE.setEnv();
      _PE.core.tweakInterface();
      _PE.core.ajax.init();
      _PE.core.startModules();
      jQuery(window).scrollTop(0);
      _PE.core.timer('Application', false, true);
      _PE.utils.trace('FRAMEWORK EXECUTION DONE in ' + _PE.framework.timings.Application.total + ' milliseconds');
    } catch (err) {
      _PE.utils.trace('_PE.core.init() FAILED', 'warn');

      var e;

      _PE.utils.trace(e);
    }
  },

  startModules: function() {
    _PE.event.trigger('onBeforeModuleStart');

    try {
      if (_PE.modules) {
        // First run modules defined in the moduleOrder array:
        jQuery.each(_PE.config.moduleOrder, function(index, obj) {
          if (typeof _PE.modules[obj] === 'object') {
            var currentMod = _PE.modules[obj];

            jQuery.extend(currentMod, _PE.baseModule);
            _PE.core.extendModule(obj);
            currentMod.done = true;
            currentMod.module = currentMod;
            /* eslint-disable no-underscore-dangle*/
            currentMod._construct();
          }
        });
        // Run the rest
        jQuery.each(_PE.modules, function(index) {
          if (!this.done) {
            this.done = true;
            this.module = this;
            jQuery.extend(this, _PE.baseModule);
            _PE.core.extendModule(index);
            this._construct();
            /* eslint-enable no-underscore-dangle*/
          }
        });
      }
    } catch (err) {
      var e;

      _PE.utils.trace(e);
    }

    _PE.event.trigger('onModulesReady');
  },

  extendModule: function(module) {
    var extension = _PE.modules[module];

    if (typeof extension.extendsOn !== 'undefined') {
      var base = _PE.modules[extension.extendsOn];

      /* eslint-disable no-negated-condition*/
      if (typeof base !== 'object') {
        /* eslint-disable max-len */
        _PE.utils.trace('MODULE:' + module + ' was not extended with MODULE:' + extension.extendsOn + ', MODOULE:' + extension.extendsOn + ' is not a valid module', 'warn');
        /* eslint-enable max-len */
      } else {
        _PE.utils.trace('MODULE:' + module + ' extended with MODULE:' + extension.extendsOn);

        // Bind the super "class" init() method to extension
        /* We make a copy of the base, rather then storing a reference to the base*/
        /* eslint-disable no-underscore-dangle*/
        extension.__init = base.init;

        /* eslint-enable no-underscore-dangle*/
        /* Extend below might seem unlogical, but we extend the module with the base and then override it again with the module itself,
           This way we are sure references to the module object remains untouched, it's a slight overhead, but not worth mentioning. */
        var tmpobj = jQuery.extend({}, base, extension);

        jQuery.extend(extension, tmpobj);
      }
    }
  },

  attachData: function(elements, type) {
    try {
      jQuery.each(elements, function(index, obj) {
        var oData = _PE.core.parseClassData(obj.className);

        jQuery(this).data(type, {
          data: oData
        });
      });
    } catch (err) {
      _PE.utils.trace('Error caught in _PE.core.attachData ', 'warn');

      var e;

      _PE.utils.trace(e);
    }
  },

  attachController: function(element, type) {
    try {
      var elements = element.elements;

      jQuery.each(elements, function() {
        jQuery(this).data(type, {
          controller: element
        });
      });
    } catch (err) {
      _PE.utils.trace('Error caught in _PE.core.attachController', 'warn');

      var e;

      _PE.utils.trace(e);
    }
  },

  getControllerFromView: function(selector) {
    if (typeof jQuery(selector).data('controller') !== 'undefined') {
      return jQuery(selector).data('controller').controller;
    }

    return false;
  },

  addFormData: function(form, key, value) {
    var existing = form.find('input[name*=' + key + ']');

    if (existing.length > 0) {
      existing.val(value);
    } else {
      /* eslint-disable xss/no-mixed-html */
      var input = jQuery('<input></input>');

      /* eslint-enable xss/no-mixed-html */
      input.attr('type', 'hidden');
      input.attr('name', key);
      input.attr('value', value);
      input.appendTo(form);
    }
  },

  setMetaData: function() {
    /* eslint-disable valid-typeof*/
    if (typeof window.metaData === 'object' || typeof window.metaData === 'array') {
    /* eslint-enable valid-typeof*/
      _PE.metaData = window.metaData;
    }

    _PE.event.trigger('onSetMetaDataReady');
  },

  setPath: function() {
    if (typeof _PE.metaData.path !== 'undefined') {
      _PE.path = _PE.core.parsePath(_PE.metaData.path);
    } else {
      _PE.path = [];
    }

    _PE.event.trigger('onSetPathReady');
  },

  tweakInterface: function() {
    _PE.event.trigger('onBeforeTweakInterface');
    /* Attach browser name to html element class */
    jQuery('html').addClass(_PE.framework.env.browser);
    /* Open download links in new window */
    jQuery('._blank').attr('target', '_blank');
    jQuery('.no-autocomplete').attr('autocomplete', 'off');
    _PE.event.trigger('onTweakInterfaceReady');
  },

  timer: function(item, start) {
    var date = new Date();

    if (start) {
    /* eslint-disable no-array-constructor */
      _PE.framework.timings[item] = new Array();
      _PE.framework.timings[item].start = date.getTime();
      /* eslint-enable no-array-constructor */
    } else {
      _PE.framework.timings[item].stop = date.getTime();
      _PE.framework.timings[item].total = _PE.framework.timings[item].stop - _PE.framework.timings[item].start;
    }
  },

  benchmark: function(data) {
    if (!data) {
      _PE.core.timer('_Benchmark', true);
      /* eslint-enable no-negated-condition */
      _PE.core.ajax.send({
        type: 'get',
        url: _PE.config.benchmarkFile,
        data: {},
        success: _PE.core.benchmark
      });
    } else {
      _PE.core.timer('_Benchmark', false);
      /* eslint-disable no-underscore-dangle*/
      _PE.utils.trace(_PE.utils.trace(_PE.framework.timings._Benchmark));
      /* eslint-enable no-underscore-dangle*/
    }
  },

  ajax: {
    /* eslint-disable no-console*/
    init: function() {
      console.log(' ');
    },
    /* eslint-enable no-console*/
    send: function(options) {
      var context = window;
      var success = options.success;
      var data = options.customdata || {};


      if (options.context) {
        context = options.context;
        options.context = null;
      }

      var callback = function(responseData) {
        _PE.core.createSuccess(context, responseData, success, data)();
      };

      options.success = callback;

      jQuery.ajax(options);
    },
    /* eslint-enable no-undef */
    globalFail: function() {
      _PE.utils.trace('Ajax Fail', 'warn');
    },

    globalSuccess: function(data) {
      _PE.utils.trace('Ajax Success');
      _PE.utils.trace(data);
    }

  },

  createSuccess: function(context, responseData, callback, elementData) {
    return function() {
      callback.apply(context, [
        {
          response: responseData,
          custom: elementData
        }
      ]);
    };
  },

  parsePath: function(path) {
    var arrPath = path.split('/');
    var arrTemp = [];

    for (var i = 0; i < arrPath.length; i = i + 1) {
      if (arrPath[i] !== '') {
        arrTemp.push(arrPath[i]);
      }
    }

    if (arrTemp.length === 0) {
      arrTemp.push('/');
    }

    return arrTemp;
  }
};
/* _PE Utils  */

if (typeof _PE === 'undefined') {
  _PE = {};
}

_PE.utils = {
  counter: 1,
  trace: function(trace, level) {
    try {
      // Create timestamp
      var d = new Date();

      // Create increment:
      var i = this.counter;

      /* eslint-disable operator-assignment*/
      this.counter += 1;

      /* eslint-enable operator-assignment*/
      if (_PE.config.debug || window.showTrace) {
        if (typeof console === 'object') {
        /* eslint-disable no-console */
          if (typeof trace === 'string' || typeof trace === 'number' || typeof console.dir !== 'function') {
          /* eslint-disable max-depth*/
            if (level && console[level]) {
            /* eslint-enable max-depth*/
              console[level](i + ') Trace: [' + d.getTime() + '] ' + trace);
            } else {
              console.info(i + ') Trace: [' + d.getTime() + '] ' + trace);
            }
          } else {
            console.info(i + ') Trace: [' + d.getTime() + ']');
            console.dir(trace);
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
};
/* eslint-enable no-console */
/* Global Error and Trace handling */

(function() {
  if (typeof _PE.config === 'object' && _PE.config.globalErrorHandling) {
    if (typeof _PE.utils.trace !== 'undefined' && _PE.config.debug) {
      _PE.utils.trace('Global Error handling is enabled');
    }

    window.trace = [];
    window.onerror = function(msg, url, line) {
      window.trace.push(msg + ' - Line:' + line);

      if (typeof _PE.utils.trace !== 'undefined') {
        var err = {};

        /* eslint-disable  max-statements-per-line */
        err.msg = msg; err.url = url; err.line = line;
        _PE.utils.trace('WINDOW.ONERROR', 'warn');
        _PE.utils.trace(err, 'error');
        /* eslint-enable  max-statements-per-line */
      }

      return true;
    };
  } else if (typeof _PE.utils.trace !== 'undefined') {
    _PE.utils.trace('Global Error handling is disabled');
  }

  if (typeof _PE.config === 'object' && _PE.config.UrlShowTrace) {
    // Determine if "showTrace" exists in the URL:
    if (document.location.href.indexOf('showTrace') > 0) {
      window.showTrace = true;
      window.onload = function() {
        if (window.trace.length > 0) {
          if (typeof window.console === 'undefined') {
          /* eslint-disable no-alert*/
            alert(window.trace.join('\n'));
            /* eslint-enable no-alert*/
          } else {
            window.console.dir(window.trace);
          }
        }
      };
    }
  }
})();
/* eslint-enable  block-scoped-var */
/* eslint-enable vars-on-top */
/* eslint-enable id-length */
/* eslint-enable init-declarations */
// If (console !== undefined && console.log !== undefined && atob !== undefined) console.log('%c'+atob('ICBfX19fICBfIF8gICAgICAgXyAgICAgIF9fXyAgICAgICBfICAgICAgICAgICAgICAgICAgICAgIF8gICBfICAgICAgICAgICAgDQogfCBfXyApfCAoXylfIF9fIHwgfCBfXyB8XyBffF8gX18gfCB8XyBfX18gXyBfXyBfXyBfICBfX198IHxfKF8pXyAgIF9fX19fICANCiB8ICBfIFx8IHwgfCAnXyBcfCB8LyAvICB8IHx8ICdfIFx8IF9fLyBfIFwgJ19fLyBfYCB8LyBfX3wgX198IFwgXCAvIC8gXyBcIA0KIHwgfF8pIHwgfCB8IHwgfCB8ICAgPCAgIHwgfHwgfCB8IHwgfF8gIF9fLyB8IHwgKF98IHwgKF9ffCB8X3wgfFwgViAvICBfXy8gDQogfF9fX18vfF98X3xffCB8X3xffFxfXCB8X19ffF98IHxffFxfX1xfX198X3wgIFxfXyxffFxfX198XF9ffF98IFxfLyBcX19ffCANCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIA0KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgVzogaHR0cDovL3RoaW5rYmxpbmsubmwgDQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgVDogKzMxKDApIDUzIDQzMSAwNyAwNSANCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIA0K'), window.navigator.userAgent.toLowerCase().indexOf('webkit') === -1 ? 'background: #2fa3cd; font-weight: 900; font-family: courier; color: #fff; text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5); border: 1px solid #2fa3cd;' : 'background: #2fa3cd; font-weight: 900; font-family: courier; color: #fff; text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);');
/* eslint-enable max-lines */
